export default "__VITE_ASSET__CT7xMst$__"